const defaultState = {
   initialState: {},
   currentState: {}
}

export const secondaryMenuItemSelectionReducer = (
   state = defaultState,
   action
) => {
   switch (action.type) {
      case 'SET_SECONDARY_MENU_ITEM_SELECTION_INITIAL_STATE':
         return {
            currentState: action.selectableSecondaryMenuItems,
            initialState: action.selectableSecondaryMenuItems
         }
      case 'SECONDARY_MENU_ITEM_SELECTED':
         return {
            ...state,
            currentState: {
               ...state.initialState,
               [action.itemTitle]: true
            }
         }
      default:
         return state
   }
}

export const mainMenuItemSelectionReducer = (state = defaultState, action) => {
   switch (action.type) {
      case 'SET_MAIN_MENU_ITEM_SELECTION_INITIAL_STATE':
         return {
            currentState: action.selectableMainMenuItems,
            initialState: action.selectableMainMenuItems
         }
      case 'MAIN_MENU_ITEM_SELECTED':
         return {
            ...state,
            currentState: {
               ...state.initialState,
               [action.itemTitle]: true
            }
         }
      default:
         return state
   }
}

export const itemWithLinkSelectionReducer = (state = defaultState, action) => {
   switch (action.type) {
      case 'SET_ITEM_WITH_LINK_SELECTION_INITIAL_STATE':
         return {
            currentState: action.selectableItemsWithLink,
            initialState: action.selectableItemsWithLink
         }
      case 'ITEM_WITH_LINK_SELECTED':
         return {
            ...state,
            currentState: {
               ...state.initialState,
               [action.itemTitle]: true
            }
         }
      default:
         return state
   }
}
